import React, { useEffect, useState, useRef } from "react";
import connect from "react-redux/lib/connect/connect";
import { api_url } from "../../common/cores/keys";
import axios from "axios";
import {
  checkLoginId,
  isEmpty,
  showMessage,
  signUp,
  toastr,
  checkLoginIdstr,
} from "../../common/cores";
import { getBankName } from "../../common/actions/userActions";
import { DatePicker } from "antd";
import moment from "moment";
import Headbar from "./Headbar";
import { isMobile } from "../../utils/utils";

const Register = (props) => {
  const dateFormat = "YYYY-MM-DD";
  const registerRef = useRef();
  const { bankList, language } = props;
  const [inputs, setInputs] = useState({
    code: "",
    loginId: "",
    loginPwd: "",
    loginPwd_confirm: "",
    name: "",
    bankName: "",
    accountNumber: "",
    masterName: "",
    withdrawPassword: "",
    withdrawPassword_confirm: "",
    tel: "",
    gender: "1",
    birthday: "",
  });
  const {
    loginId,
    loginPwd,
    loginPwd_confirm,
    name,
    bankName,
    accountNumber,
    masterName,
    withdrawPassword,
    withdrawPassword_confirm,
    tel,
    code,
    gender,
    birthday,
  } = inputs;

  const [error, setError] = useState({});

  const onChangeBirthday = (date, dateString) => {
    // console.log("====================>", date, dateString);
    setInputs({
      ...inputs,
      birthday: dateString,
    });
  };

  useEffect(() => {
    getBankName();
  }, []);

  const onChange = (e) => {
    const { value, name } = e.target; // 우선 e.target 에서 name 과 value 를 추출
    setInputs({
      ...inputs, // 기존의 input 객체를 복사한 뒤
      [name]: value, // name 키를 가진 값을 value 로 설정
    });
  };

  const onReset = () => {
    setInputs({
      code: "",
      loginId: "",
      loginPwd: "",
      loginPwd_confirm: "",
      name: "",
      bankName: "",
      accountNumber: "",
      masterName: "",
      withdrawPassword: "",
      withdrawPassword_confirm: "",
      tel: "",
      gender: "1",
      birthday: "",
      error: {},
    });
  };

  const onCheckDuplication = () => {
    if (isEmpty(loginId))
      return toastr.warning(
        isEmpty(window.lang["아이디를 입력해 주세요."])
          ? "아이디를 입력해 주세요."
          : window.lang["아이디를 입력해 주세요."]
      );
    if (checkLoginIdstr(loginId))
      return setError({
        loginId: isEmpty(window.lang["아이디에 특수문자를 포함할수 없습니다."])
          ? "아이디에 특수문자를 포함할수 없습니다."
          : window.lang["아이디에 특수문자를 포함할수 없습니다."],
      });
    checkLoginId(loginId)
      .then((res) => {
        setError({});
        if (res.data.status === 0) {
          toastr.success(
            isEmpty(window.lang["이용가능한 아이디입니다."])
              ? "이용가능한 아이디입니다."
              : window.lang["이용가능한 아이디입니다."]
          );
        } else {
          const { message } = res.data;
          showMessage(message);
        }
      })
      .catch((err) => {
        console.log(err);
        setError({});
        if (err.response === undefined) {
          toastr.warning("잠시후 다시 시도해주세요.");
          return;
        }
      });
  };

  const onRegister = () => {
    // e.prevendivefault();
    setError({});

    let params = {
      code,
      loginId,
      loginPwd,
      loginPwd_confirm,
      name,
      bankName,
      accountNumber,
      masterName,
      withdrawPassword,
      withdrawPassword_confirm,
      tel,
      gender,
      birthday,
    };

    let err = {};
    if (isEmpty(loginId))
      err.loginId = isEmpty(window.lang["아이디를 입력해 주세요."])
        ? "아이디를 입력해 주세요."
        : window.lang["아이디를 입력해 주세요."];
    if (checkLoginIdstr(loginId))
      err.loginId = isEmpty(
        window.lang["아이디에 특수문자를 포함할수 없습니다."]
      )
        ? "아이디에 특수문자를 포함할수 없습니다."
        : window.lang["아이디에 특수문자를 포함할수 없습니다."];
    if (isEmpty(name))
      err.name = isEmpty(window.lang["닉네임을 입력하세요"])
        ? "닉네임을 입력하세요"
        : window.lang["닉네임을 입력하세요"];
    if (isEmpty(birthday)) {
      err.birthday = isEmpty(window.lang["생년월일을 입력하세요."])
        ? "생년월일을 입력하세요."
        : window.lang["생년월일을 입력하세요."];
    }
    if (isEmpty(gender)) {
      err.gender = "성별을 입력해주세요.";
    }
    if (isEmpty(loginPwd))
      err.loginPwd = isEmpty(window.lang["비밀번호를 입력해 주세요."])
        ? "비밀번호를 입력해 주세요."
        : window.lang["비밀번호를 입력해 주세요."];
    if (isEmpty(loginPwd_confirm))
      err.loginPwd_confirm = isEmpty(window.lang["비번확인을 입력하세요."])
        ? "비번확인을 입력하세요."
        : window.lang["비번확인을 입력하세요."];
    if (isEmpty(tel) || tel.length < 11) err.tel = "핸드폰번호를 입력해주세요.";
    if (isEmpty(code))
      err.code = isEmpty(window.lang["추천코드를 입력하세요"])
        ? "추천코드를 입력하세요"
        : window.lang["추천코드를 입력하세요"];
    if (isEmpty(withdrawPassword))
      err.withdrawPassword = isEmpty(window.lang["환전 비밀번호를 입력하세요"])
        ? "환전 비밀번호를 입력하세요"
        : window.lang["환전 비밀번호를 입력하세요"];
    if (isEmpty(withdrawPassword_confirm)) {
      err.withdrawPassword_confirm = isEmpty(
        window.lang["환전비번확인을 입력하세요"]
      )
        ? "환전비번확인을 입력하세요"
        : window.lang["환전비번확인을 입력하세요"];
      if (withdrawPassword !== withdrawPassword_confirm)
        err.withdrawPassword_confirm = isEmpty(
          window.lang["환전비번확인을 입력하세요"]
        )
          ? "환전비번확인을 입력하세요"
          : window.lang["환전비번확인을 입력하세요"];
    }
    if (isEmpty(bankName))
      err.bankName = isEmpty(window.lang["은행명을 입력해주세요."])
        ? "은행명을 입력해주세요."
        : window.lang["은행명을 입력해주세요."];
    if (isEmpty(masterName))
      err.masterName = isEmpty(window.lang["예금주를 입력하세요"])
        ? "예금주를 입력하세요"
        : window.lang["예금주를 입력하세요"];
    if (isEmpty(accountNumber))
      err.accountNumber = isEmpty(window.lang["계좌번호를 입력하세요"])
        ? "계좌번호를 입력하세요"
        : window.lang["계좌번호를 입력하세요"];

    if (!isEmpty(err)) return setError(err);

    signUp(params)
      .then((res) => {
        setError({});
        const { status, errors, message } = res.data;
        showMessage(message);
        if (!status) {
          props.history.push("/login");
        } else {
          setError(errors);
        }
      })
      .catch((err) => {
        console.log(err);
        setError({});
        // if (err.response && err.response.status === 401) {
        //     props.logoutUser();
        // } else {
        toastr.warning("잠시후 다시 시도해주세요.");
        // }
      });
  };
  useEffect(() => {
    registerRef.current.focus();
  }, []);

  useEffect(() => {}, [language]);

  return (
    <div className="layoutBody" style={{ paddingTop: "0px" }}>
      <div className="wrapper  lang_ko" id="bodyTemplate">
        <div id="contentTheme"></div>
        <Headbar />
      </div>
      <div className="container-fluid joinwrap">
        <div className="center_box" style={{ paddingTop: isMobile() && "5px" }}>
          <div className="con_box00">
            <div className="write_wrap">
              <div className="write3">
                <div className="write_title_top">
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["아이디"])
                        ? "아이디"
                        : window.lang["아이디"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <input
                          name="loginId"
                          onChange={onChange}
                          className="input1 width-id-input"
                          ref={registerRef}
                          placeholder={
                            isEmpty(window.lang["아이디를 입력해 주세요."])
                              ? "아이디를 입력해 주세요."
                              : window.lang["아이디를 입력해 주세요."]
                          }
                        />
                        <span
                          className="btn1_1 cursor-point"
                          onClick={onCheckDuplication}
                        >
                          {" "}
                          {isEmpty(window.lang["증복확인"])
                            ? "증복확인"
                            : window.lang["증복확인"]}
                        </span>
                        {/* <div className="margin-auto text-align-center reg_p_5"> 아이디는 4 ~ 16자리 입니다.</div> */}
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.loginId) && error.loginId}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["닉네임"])
                        ? "닉네임"
                        : window.lang["닉네임"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <input
                          name="name"
                          onChange={onChange}
                          className="input1"
                        />
                        <div> </div>
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.name) && error.name}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["생년월일"])
                        ? "생년월일"
                        : window.lang["생년월일"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <DatePicker
                          defaultValue={moment("1990-01-01", dateFormat)}
                          onChange={onChangeBirthday}
                        />
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.birthday) && error.birthday}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["성별"])
                        ? "성별"
                        : window.lang["성별"]}
                    </div>
                    <div
                      className="write_basic pc-mobile-reg"
                      style={{
                        backgroundColor: "unset",
                        border: "none",
                        display: "unset",
                      }}
                    >
                      <div className="input-control">
                        <label className="radio_container pr-4">
                          {isEmpty(window.lang["남성"])
                            ? "남성"
                            : window.lang["남성"]}
                          <input
                            type="checkbox"
                            name="gender"
                            checked={gender === "1" && "checked"}
                            className="sex_input"
                            value="1"
                            onChange={onChange}
                          />
                          <span className="checkmark"></span>
                        </label>
                        <label className="radio_container">
                          {isEmpty(window.lang["여성"])
                            ? "여성"
                            : window.lang["여성"]}
                          <input
                            type="checkbox"
                            name="gender"
                            checked={gender === "0" && "checked"}
                            className="sex_input"
                            value="0"
                            onChange={onChange}
                          />
                          <span className="checkmark"></span>
                        </label>
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.name) && error.name}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["비밀번호"])
                        ? "비밀번호"
                        : window.lang["비밀번호"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <input
                          type="password"
                          name="loginPwd"
                          onChange={onChange}
                          className="input1"
                        />
                        {/* <div className="margin-auto text-align-center reg_p_5"> 패스워드는 6 ~ 16자리 입니다. </div> */}
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.loginPwd) && error.loginPwd}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["비밀번호 확인"])
                        ? "비밀번호 확인"
                        : window.lang["비밀번호 확인"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <input
                          name="loginPwd_confirm"
                          onChange={onChange}
                          type="password"
                          className="input1"
                        />
                        <div className="margin-auto"> </div>
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.loginPwd_confirm) &&
                          error.loginPwd_confirm}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["휴대폰 번호"])
                        ? "휴대폰 번호"
                        : window.lang["휴대폰 번호"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <input
                          name="tel"
                          onChange={onChange}
                          maxLength="13"
                          className="input1"
                          placeholder={
                            isEmpty(window.lang["- 빼고 입력해 주세요"])
                              ? "- 빼고 입력해 주세요"
                              : window.lang["- 빼고 입력해 주세요"]
                          }
                        />
                        <div className="margin-auto"> </div>
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.tel) && error.tel}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["은행명"])
                        ? "은행명"
                        : window.lang["은행명"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <select
                          className="input1 bankSelect"
                          onChange={onChange}
                          name="bankName"
                        >
                          <option defaultValue="">
                            {isEmpty(window.lang["은행선택"])
                              ? "은행선택"
                              : window.lang["은행선택"]}
                          </option>
                          {!isEmpty(bankList) &&
                            bankList.map((list, index) => {
                              return (
                                <option
                                  defaultValue={list.bankName}
                                  key={index}
                                >
                                  {list.bankName}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      <div className="margin-auto"> </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.bankName) && error.bankName}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["예금주"])
                        ? "예금주"
                        : window.lang["예금주"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <input
                          name="masterName"
                          onChange={onChange}
                          className="input1"
                        />
                        <div> </div>
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.masterName) && error.masterName}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["계좌번호"])
                        ? "계좌번호"
                        : window.lang["계좌번호"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <input
                          name="accountNumber"
                          onChange={onChange}
                          className="input1"
                        />
                        <div> </div>
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.accountNumber) && error.accountNumber}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["환전 비밀번호"])
                        ? "환전 비밀번호"
                        : window.lang["환전 비밀번호"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <input
                          name="withdrawPassword"
                          type="password"
                          onChange={onChange}
                          className="input1"
                        />
                        <div> </div>
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.withdrawPassword) &&
                          error.withdrawPassword}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["환전 비밀번호 확인"])
                        ? "환전 비밀번호 확인"
                        : window.lang["환전 비밀번호 확인"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <input
                          name="withdrawPassword_confirm"
                          type="password"
                          onChange={onChange}
                          className="input1"
                        />
                        <div> </div>
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.withdrawPassword_confirm) &&
                          error.withdrawPassword_confirm}
                      </div>
                    </div>
                  </div>
                  <div className="pc-mobile-reg">
                    <div className="write_title write_title_reg reg_w_100">
                      {isEmpty(window.lang["추천코드"])
                        ? "추천코드"
                        : window.lang["추천코드"]}
                    </div>
                    <div>
                      <div className="write_basic pc-mobile-reg">
                        <input
                          name="code"
                          onChange={onChange}
                          className="input1"
                        />
                        <div> </div>
                      </div>
                      <div
                        className="color-danger text-align-center"
                        style={{ fontSize: "12px" }}
                      >
                        {!isEmpty(error.code) && error.code}
                      </div>
                    </div>
                  </div>
                  <div className="btn_wrap_center" style={{ marginTop: 20 }}>
                    <ul>
                      <li>
                        <a onClick={onRegister}>
                          <div className="btn3_1">
                            {isEmpty(window.lang["회원가입"])
                              ? "회원가입"
                              : window.lang["회원가입"]}
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="con_box30"></div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  bankList: state.user.bankList,
  language: state.more.language,
});

export default connect(mapStateToProps)(Register);



// WEBPACK FOOTER //
// ./src/components/Layout/Register.js